/* ===========================================================================
© Mesomorphic Ltd
============================================================================= */
document.addEventListener('turbolinks:load', () => {
  const form = document.getElementById('gansey-pattern-form');
  if (!form) return;

  // Cache the base radios and percentage fields.
  const baseRadios = Array.from(form.querySelectorAll('.base-carrier-radio'));
  const percentageFields = Array.from(form.querySelectorAll('.percentage-field'));
  const submitButton = document.getElementById('submit-button');
  if (!submitButton) return;

  // Update the submit button state based on the base radio selection.
  function checkBaseCarrierSelection() {
    const count = baseRadios.filter(radio => radio.checked && !radio.disabled).length;
    if (count === 1) {
      submitButton.disabled = false;
      submitButton.removeAttribute('title');
    } else {
      submitButton.disabled = true;
      submitButton.setAttribute('title', 'Please select exactly one base carrier.');
    }
  }

  // Ensure only one radio is selected at a time.
  baseRadios.forEach(radio => {
    radio.addEventListener('change', function checkBaseRadios() {
      if (radio.checked) {
        baseRadios.forEach(otherRadio => {
          if (otherRadio !== this) {
            otherRadio.checked = false;
          }
        });
      }
      checkBaseCarrierSelection();
    });
  });

  // Update the state of each associated radio based on its percentage field.
  percentageFields.forEach(field => {
    const radioId = field.dataset.baseRadio;
    const radio = document.getElementById(radioId);
    if (!radio) return;

    function updateRadioState() {
      // Safely handle null/undefined values with a fallback to empty string.
      if ((field.value || '').trim() === '') {
        radio.disabled = true;
        if (radio.checked) radio.checked = false;
      } else {
        radio.disabled = false;
      }
      checkBaseCarrierSelection();
    }

    updateRadioState();
    field.addEventListener('input', updateRadioState);
  });

  // Perform an initial check on load.
  checkBaseCarrierSelection();
});
